import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  education: Entry[];
  title?: string;
}

export const Education: FC<Props> = ({ education, title = 'Education' }) => (
  <Section title={title}>
    {education.map((item, i) => (
      <EntryBlock
        key={`${item.institution}-${i}`}
        entry={item}
        title={item.institution}
        role={[item.studyType, item.area].filter(Boolean).join(' ')}
        location={item.location}
      >
        {item.score && <p className="cv-note cv-sub">{item.score}</p>}
        {item.specialization && <p className="cv-note cv-sub cv-italic">{item.specialization}</p>}
        {item.courses && item.courses.length > 0 && (
          <ul className="cv-bullets">
            {item.courses.map(course => (
              <li key={course}>{course}</li>
            ))}
          </ul>
        )}
      </EntryBlock>
    ))}
  </Section>
);

export default Education;
